import React, { FunctionComponent, SyntheticEvent, useState } from "react"
import profileImage from '../assets/img/profile-photo.png'
import styled from 'styled-components'
import { styles } from "../styles/themes/style"
import TooltipWrapper from "./TooltipWrapper"


interface IProfilePhotoProps {
    tooltipMessage?: string
    source?: string
    capitalLetters?: string
    className?: string
    allowTooltip?: boolean
    height?: string
    width?: string
    minWidth?: string
    minHeight?: string
}

const ProfilePhoto: FunctionComponent<IProfilePhotoProps> = ({ tooltipMessage, source, capitalLetters, allowTooltip = true, ...props }) => {
    const isSourceMissing = !source || source.trim() === '';
    const [imgError, setImgError] = useState(false);

    //Event handlers
    const setFallbackImage = (event: SyntheticEvent<HTMLImageElement>) => {
        let target = event.target as HTMLImageElement
        target.src = profileImage
    }

    const shouldShowLetters = (isSourceMissing || imgError)
    const lettersToShow = !!capitalLetters?.length ? capitalLetters : 'NN'
    const tooltipText = allowTooltip ? (tooltipMessage ?? (shouldShowLetters ? lettersToShow.toString() : capitalLetters?.toString() ?? '')) : ''

    return (<TooltipWrapper tooltipText={tooltipText}>
        {shouldShowLetters ? (
            <StyledLetters {...props}>{ lettersToShow }</StyledLetters>
        ) : (
            <StyledImage
                {...props}
                src={source}
                alt='actions-button'
                onError={(img) => {
                    setImgError(true)
                    setFallbackImage(img)
                }}
            />
        )}
    </TooltipWrapper>)
}
const StyledImage = styled.img`
    width: ${({width}) => width ?? '32px'}};
    height: ${({height}) => height ?? '32px'}};
    border-radius: 50%;

    &.header-profile-avatar {
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
        outline: 2px solid ${styles.colors.white};
        outline-offset: 0;
    }
`

const StyledLetters = styled.span<IProfilePhotoProps>`  
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: ${({minWidth}) => minWidth ?? '24px'}};
    min-height: ${({minHeight}) => minHeight ?? '24px'}};
    width: ${({width}) => width ?? '32px'}};
    height: ${({height}) => height ?? '32px'}};
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
    line-height: 24px;
    text-align: center;
    color: ${styles.colors.primary600};
    
    background-color: ${styles.colors.primary100};

    &.header-profile-avatar {
        font-size: 12px;
        font-weight: 600;
        color: ${styles.colors.black600};
        background: linear-gradient(135deg, rgb(181, 177, 241), rgb(209, 130, 237));
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
        outline: 2px solid ${styles.colors.white};
        outline-offset: 0;
    }

    /* Inbox conversation list initials background */
    &.inbox-conversation-avatar {
        background-color: #DBE3FF;
    }

    &.connection-version-in-1st {
            color: ${styles.colors.yellow600};
            background-color: #FEF8E7;
    }

    &.connection-version-in-2nd {
        color: ${styles.colors.primary600};
        background-color: ${styles.colors.primary100};
    }

    &.connection-version-imported {
            color: ${styles.colors.black300};
            background-color: ${styles.colors.uiBackground};
    }

    &.connection-version-in-regular {
            color: ${styles.colors.black300};
            background-color: ${styles.colors.uiBackground};
    }

    &.connection-version-in-prospect {
            color: ${styles.colors.primary100};
            background-color: ${styles.colors.blue200};
    }
`
export default ProfilePhoto